import { AxiosWithCancelGet, ErrorHandler, IpHandler } from '@@types/Api';

import ChannelApi from '~/stores/providers/Api/Channel';
import CommandApi from '~/stores/providers/Api/Command';
import CommandAppApi from '~/stores/providers/Api/CommandApp';
import CommonApi from '~/stores/providers/Api/Common';
import DepartmentApi from '~/stores/providers/Api/Department';
import FileApi from '~/stores/providers/Api/File';
import HookApi from '~/stores/providers/Api/Hook';
import LogApi from '~/stores/providers/Api/Log';
import MeApi from '~/stores/providers/Api/Me';
import MemberApi from '~/stores/providers/Api/Member';
import NoticeApi from '~/stores/providers/Api/Notice';
import OrganizationApi from '~/stores/providers/Api/Organization';
import PhoneApi from '~/stores/providers/Api/Phone';
import SettingApi from '~/stores/providers/Api/Setting';
import SideAppApi from '~/stores/providers/Api/SideApp';
import StickerApi from '~/stores/providers/Api/Sticker';
import TenantApi from '~/stores/providers/Api/Tenant';
import logging from '~/stores/providers/logging';
import { createRequester, getContents, getResult } from '~/utils/apiUtil';

class Api {
  contentsRequester: AxiosWithCancelGet;
  resultRequester: AxiosWithCancelGet;
  ignoreErrorRequester: AxiosWithCancelGet;
  rawRequester: AxiosWithCancelGet;

  errorHandler: ErrorHandler = (error: Error) => {
    logging.log('[Default Error Handler] error', error);
  };

  ipHandler: IpHandler = (ip: string) => {
    logging.log('ip', ip);
  };

  common: CommonApi;
  member: MemberApi;
  me: MeApi;
  tenant: TenantApi;
  setting: SettingApi;
  command: CommandApi;
  organization: OrganizationApi;
  channel: ChannelApi;
  log: LogApi;
  file: FileApi;
  sticker: StickerApi;
  hook: HookApi;
  notice: NoticeApi;
  phone: PhoneApi;
  department: DepartmentApi;
  sideApp: SideAppApi;
  commandApp: CommandAppApi;

  initialize = (errorHandler: ErrorHandler = this.errorHandler, ipHandler: IpHandler = this.ipHandler) => {
    this.errorHandler = errorHandler;
    this.ipHandler = ipHandler;
    this.setHandlers();

    this.common = new CommonApi(this);
    this.member = new MemberApi(this);
    this.me = new MeApi(this);
    this.tenant = new TenantApi(this);
    this.setting = new SettingApi(this);
    this.command = new CommandApi(this);
    this.organization = new OrganizationApi(this);
    this.channel = new ChannelApi(this);
    this.log = new LogApi(this);
    this.file = new FileApi(this);
    this.sticker = new StickerApi(this);
    this.hook = new HookApi(this);
    this.notice = new NoticeApi(this);
    this.phone = new PhoneApi(this);
    this.department = new DepartmentApi(this);
    this.sideApp = new SideAppApi(this);
    this.commandApp = new CommandAppApi(this);
  };

  setErrorHandler = (errorHandler: ErrorHandler) => {
    this.errorHandler = errorHandler;
    this.setHandlers();
  };

  setIpHandler = (ipHandler: IpHandler) => {
    this.ipHandler = ipHandler;
    this.setHandlers();
  };

  private setHandlers = () => {
    this.contentsRequester = createRequester(this.errorHandler, this.ipHandler, { unWrapper: getContents });
    this.resultRequester = createRequester(this.errorHandler, this.ipHandler, { unWrapper: getResult });
    this.ignoreErrorRequester = createRequester(this.errorHandler, this.ipHandler, { ignoreError: true });
    this.rawRequester = createRequester(this.errorHandler, this.ipHandler, {});
  };
}

export default Api;

export const api = new Api();
